import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import './Style/Pagination.css';

const Pagination = ({
  totalCount,
  currentPage,
  itemsPerPage = process.env.NODE_ENV === 'development' ? 10 : 50,
  onPageChange,
  onItemsPerPageChange,
  availableItemsPerPage = [10, 20, 50, 100, 200],
}) => {
  // Precompute values that don’t call hooks
  const minOption = Math.min(...availableItemsPerPage);
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  // Window width for responsive maxVisiblePages
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [maxVisiblePages, setMaxVisiblePages] = useState(5);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth < 480) {
      setMaxVisiblePages(5);
    } else if (windowWidth < 768) {
      setMaxVisiblePages(7);
    } else {
      setMaxVisiblePages(9);
    }
  }, [windowWidth]);

  // Hide entirely if fewer items than smallest page-size
  if (totalCount < minOption) return null;


  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const handleItemsPerPageChange = (selectedOption) => {
    const newItemsPerPage = selectedOption.value;
    onItemsPerPageChange(newItemsPerPage);
    const newTotalPages = Math.ceil(totalCount / newItemsPerPage);
    if (currentPage > newTotalPages) {
      onPageChange(newTotalPages);
    }
  };

  // Compute which page buttons to show
  const half = Math.floor(maxVisiblePages / 2);
  const startPage = Math.max(1, currentPage - half);
  const endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  const pages = [];
  for (let i = startPage; i <= endPage; i++) {
    pages.push(i);
  }

  const availableOptions = availableItemsPerPage.map(count => ({
    value: count,
    label: `${count}`
  }));

  return (
    <div className="pagination-container">
      <div className="items-per-page">
        <label htmlFor="items-per-page">Filas por página:</label>
        <Select
          id="items-per-page"
          value={availableOptions.find(opt => opt.value === itemsPerPage)}
          onChange={handleItemsPerPageChange}
          options={availableOptions}
          menuPlacement="top"
          isSearchable={false}
        />
      </div>

      <div className="pagination">
        <button
          className="page-btn"
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
        >
          Anterior
        </button>

        {pages.map(page => (
          <button
            key={page}
            onClick={() => handlePageChange(page)}
            className={`page-btn ${page === currentPage ? 'active' : ''}`}
          >
            {page}
          </button>
        ))}

        <button
          className="page-btn"
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          data-testid="next-page-button"
        >
          Siguiente
        </button>
      </div>
    </div>
  );
};

export default Pagination;
